import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';

import AmbulatoryPsychotherapy from './AmbulatoryPsychotherapy';
import Clinics from './Clinics';
import Specialists from './Specialists';

const Supplynetwork = (props) => {
  return (
    <Switch>
      <Route
        path={`${props.match.path}/AmbulatoryPsychotherapy`}
        component={AmbulatoryPsychotherapy}
      />
      <Route path={`${props.match.path}/clinics`} component={Clinics} />
      <Route path={`${props.match.path}/Specialists`} component={Specialists} />
    </Switch>
  );
};

export default withRouter(Supplynetwork);
